<template>
	<div class="card p-0 position-relative" v-load-page="'/' + props.basic + '/' + props.card_data.slug">
		<!-- Admin dropdown -->
		<div v-if="isAdmin && dropdown" class="position-absolute top-0 end-0 p-2" style="z-index: 100" @click.stop>
			<div class="dropdown">
				<i class="hoverable-icon bi-three-dots-vertical" data-bs-toggle="dropdown" aria-expanded="false"></i>
				<ul class="dropdown-menu dropdown-menu-end">
					<li><a class="dropdown-item" href="#" @click.prevent="openEditModal">Edit description</a></li>
				</ul>
			</div>
		</div>
		<div class="card-img-wrapper">
			<img class="card-img-top" :src="randomImages[Math.floor(Math.random() * randomImages.length)]">
		</div>
		<div class="card-body">
			<h5 class="card-title m-0 fw-medium" v-max-lines="2">
				{{ props.card_data.name }}
			</h5>
			<p class="card-text fw-light fs-6 text-gray-700" v-max-lines="3">
				{{ props.card_data.about }}
			</p>
			<div class="d-flex">
				<div class="d-flex gap-3">
					<span v-for="stat in stats_left" class="d-flex gap-1 align-items-center stats-item"
					      :class="stat.containerClass" v-tooltip="stat.tooltipText">
						<i v-if="stat.iconType === 'bootstrap'" class="bi inline-icon h-auto"
						   :class="stat.icon + ' ' + stat.iconColor"></i>
						<span>{{ stat.value }}</span>
						<small v-if="stat.extraValue" class="text-muted">({{ stat.extraValue }})</small>
					</span>
				</div>
				<div class="ms-auto">
					<span v-for="stat in stats_right" class="d-flex gap-1 align-items-center stats-item"
					      :class="stat.containerClass" v-tooltip="stat.tooltipText">
						<i v-if="stat.iconType === 'bootstrap'" class="bi inline-icon h-auto"
						   :class="stat.icon + ' ' + stat.iconColor"></i>
						<span>{{ stat.value }}</span>
						<small v-if="stat.extraValue" class="text-muted">({{ stat.extraValue }})</small>
					</span>
				</div>
			</div>
		</div>
	</div>

</template>

<script setup>
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth-store';

const props = defineProps({
	card_data: Object,
	basic: String,
	stats_right: Array,
	stats_left: Array,
	index: Number,
	dropdown: Boolean,
});

const emit = defineEmits(['edit-modal-open']);

const auth = useAuthStore();
const isAdmin = computed(() => auth.is_admin);

const modalId = computed(() => `editAboutModal_${props.basic}_${props.card_data.id}`);

const openEditModal = () => {
	emit('edit-modal-open', {
		about: props.card_data.about || '',
		slug: props.card_data.slug,
		modalId: modalId.value,
		index: props.index,
	});
};


const randomImages = [
	'https://images.pexels.com/photos/3689307/pexels-photo-3689307.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
	'https://images.pexels.com/photos/13564526/pexels-photo-13564526.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
	'https://images.pexels.com/photos/16441669/pexels-photo-16441669/free-photo-of-mode-kvinna-flicka-sot.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
	'https://images.pexels.com/photos/12551732/pexels-photo-12551732.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
	'https://images.pexels.com/photos/13779107/pexels-photo-13779107.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
	'https://images.pexels.com/photos/4092837/pexels-photo-4092837.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
	'https://images.pexels.com/photos/9951389/pexels-photo-9951389.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
	'https://images.pexels.com/photos/14530635/pexels-photo-14530635.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
	'https://images.pexels.com/photos/8460603/pexels-photo-8460603.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
	'https://images.pexels.com/photos/16329380/pexels-photo-16329380/free-photo-of-avslappning-glas-lyx-tval.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
	'https://images.pexels.com/photos/13430311/pexels-photo-13430311.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
];
</script>

<style scoped lang="scss">
@import '../../assets/scss/variables.scss';


.card {
	font-family: 'Barlow', serif;
	border-radius: 15px;
	cursor: pointer;

	.card-img-wrapper {
		margin: 5% 5% 3%;
		border-radius: inherit;
		overflow: hidden;

		.card-img-top {
			aspect-ratio: 1;
			border-radius: inherit;
			height: 101%;
			width: 101%;

			@media (min-width: 991px) {
				transition: transform 0.3s ease-in-out;

				&:hover {
					transform: scale(1.08);
				}
			}
		}
	}


	.card-body {
		padding: 5%;
		padding-top: 0 !important;
	}

	@media (max-width: 991px) {

		.card-img-wrapper {
			margin: 5% 3% 3%;
		}

		.card-body {
			padding: 5% 3% 3%;
		}
	}

	.card-title {
		font-size: 20px;
		min-height: 48px;

		@media (max-width: 767px) {
			font-size: 17px;
			min-height: 40.8px;
		}

		@media (max-width: 575px) {
			margin-top: 1px !important;
		}
	}

	.card-text {
		min-height: 70px;
		margin-bottom: 1.4rem;
		margin-top: 0.9rem;
	}

	.stats-item {
		font-weight: 500;
		font-size: 14px;

		i {
			font-size: 16px;

			@media (max-width: 767px) {
				font-size: 14px;
			}
		}
	}
}
</style>